import { Component, OnInit } from '@angular/core';
import { JobPost } from "../../models/inModels/JobPost";
import { SelectItem, LazyLoadEvent, Message, ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';
import { DataTable } from "primeng/components/datatable/datatable";
import { JobPostService } from "../../services/business/job-post.service";
import { NotificationContentType } from "../../models/inModels/MessageModel";

@Component({
	selector: 'app-job-posts',
	templateUrl: './job-posts.component.html',
	styleUrls: ['./job-posts.component.css']
})
export class  JobPostsComponent {
	items: JobPost[];
	rows: SelectItem[];
	selectedRows: number;
	filteredRecords: number;
	rowEvent: LazyLoadEvent;
	loading: boolean;
	totalRecords: number;
	error: Message[];
	contentId: number;
	contentType: NotificationContentType;
	sendAllDialog = false;
	constructor(
		private service: JobPostService,
		private router: Router,
		private confirmationService: ConfirmationService) {
		this.loading = true;
		this.rows = [];
		this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 10;
	}

	changeRows(event): void {
		this.load(this.rowEvent);
	}

	reset(dt: DataTable, gb: HTMLInputElement) {
		gb.value = '';
		dt.reset();
	}

	load(event: LazyLoadEvent): void {
		this.loading = true;
		event.rows = this.selectedRows;
		this.rowEvent = event;
		this.service.search(event).then(
			dataPager => {
				this.items = dataPager.Data;
				this.filteredRecords = dataPager.FilteredRecords;
				this.totalRecords = dataPager.TotalRecords;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.items = [];
				this.totalRecords = 0;
				this.filteredRecords = 0;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	edit(jobPost: JobPost) {
		console.log(jobPost);
		this.router.navigate(['jobposts/edit', jobPost.Id]);
	}

	sendAllDialogOpen(jobPost: JobPost) {
		this.contentId = jobPost.Id;
		this.contentType = NotificationContentType.Job;
		this.sendAllDialog = true;
	}

	delete(jobPost: JobPost) {
		console.log(jobPost);
		this.confirmationService.confirm({
			message: `Are you sure you want to delete ${jobPost.Title}?`,
			header: 'Confirmation',
			icon: 'fa fa-trash-o',
			accept: () => {
				this.loading = true;
				this.service.delete(jobPost.Id).then(
					result => {
						this.loading = false;
						this.load(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/job-posts/job-posts.component.ts